import styled from 'styled-components';

const INPUT_HEIGHT = 50;
const RADIUS = 8;

export const CSSPlaceholder = styled.div`
    padding: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    b {
        font-size: 14px;
        color: ${(props) => props.theme.color.grey6};
    }

    i {
        font-size: 12px;
        color: ${(props) => props.theme.color.grey5};
    }

    img {
        margin-bottom: 10px;
    }
`;

export const CSSEmptyWrapper = styled.div`
    flex: 1;

    &:hover {
        .inplace-image-hover {
            opacity: 0;
        }
    }

    .inplace-image-hover {
        position: absolute;
        background-color: transparent;
        z-index: 10;
        inset: 0;
        margin: -12px;
        border: 1px dashed ${(props) => props.theme.color.grey2};
        border-radius: 8px;
        opacity: 1;
        pointer-events: none;
    }
`;

export const CSSHiddenDiv = styled.div`
    height: 0;
    overflow: hidden;
`;

export const CSSEmptyText = styled.div`
    color: ${(props) => props.theme.color.grey3};
    font-style: italic;
`;

export const CSSWrapperText = styled.div<{
    color?: string;
    heading?: string;
    fontSize?: string;
}>`
    width: 100%;
    border: 0;
    min-height: ${INPUT_HEIGHT}px;
    margin: 0;
    align-items: center;
    border-radius: ${RADIUS}px;
    cursor: pointer;
    gap: 10px;
    color: ${(props) => (props.color ? props.color : props.theme.font.color)};
    word-wrap: break-word;
    transition: opacity 0.4s;
    ${({ heading }) => heading && heading == 'h1' && `font-size: 32px;`}
    ${({ heading }) => heading && heading == 'h2' && `font-size: 24px;`}
    ${({ heading }) => heading && heading == 'h3' && `font-size: 18px;`}
    ${({ heading }) => heading && heading == 'h4' && `font-size: 16px;`}

    &:hover {
        img {
            filter: grayscale(0);
            opacity: 1;
        }
    }

    img {
        filter: grayscale(1);
        opacity: 0.4;
    }
`;

export const CSSText = styled.div`
    .widget-text-html {
        p {
            display: block;
            margin-bottom: 0px;
        }
    }
`;

export const CSSForm = styled.form`
    & > fieldset {
        margin: 0px !important;
    }
    label {
        display: none;
    }
`;

export const CSSTextareaWrapper = styled.form`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const StyledTextarea = styled.div<{ heading?: string; color?: string }>`
    width: 100%;
    color: ${(props) => (props.color ? props.color : props.theme.font.color)};
    textarea {
        :focus {
            outline: none;
            box-shadow: none;
        }
        width: 100%;
        ${({ heading }) => heading && heading == 'h1' && `font-size: 32px;`}
        ${({ heading }) => heading && heading == 'h2' && `font-size: 24px;`}
        ${({ heading }) => heading && heading == 'h3' && `font-size: 18px;`}
        ${({ heading }) => heading && heading == 'h4' && `font-size: 16px;`}
    }
    textarea::placeholder {
        ${({ heading }) => heading && heading == 'h1' && `font-size: 32px;`}
        ${({ heading }) => heading && heading == 'h2' && `font-size: 24px;`}
        ${({ heading }) => heading && heading == 'h3' && `font-size: 18px;`}
        ${({ heading }) => heading && heading == 'h4' && `font-size: 16px;`}
    }
`;

export const StyledInput = styled.div<{ heading?: string; color?: string }>`
    display: flex;
    flex: 1;
    input::placeholder {
        ${({ heading }) =>
            heading && heading == 'h1'
                ? `
        font-size: 32px;
    `
                : ``}
        ${({ heading }) =>
            heading &&
            heading == 'h2' &&
            `
        font-size: 24px;
    `}
    ${({ heading }) =>
            heading &&
            heading == 'h3' &&
            `
        font-size: 18px;
    `}
    ${({ heading }) =>
            heading &&
            heading == 'h4' &&
            `
        font-size: 16px;
    `}
    }
    div {
        cursor: text;
        color: ${(props) => (props.color ? props.color : props.theme.font.color)};
        ${({ heading }) =>
            heading && heading == 'h1'
                ? `
        font-size: 32px;
    `
                : ``}
        ${({ heading }) =>
            heading &&
            heading == 'h2' &&
            `
        font-size: 24px;
    `}
    ${({ heading }) =>
            heading &&
            heading == 'h3' &&
            `
        font-size: 18px;
    `}
    ${({ heading }) =>
            heading &&
            heading == 'h4' &&
            `
        font-size: 16px;
    `}
    }
    [data-placeholder]:empty:before {
        content: attr(data-placeholder);
        color: #888;
        font-style: italic;
    }
`;

export const CSSWidgetEditorListItem = styled.div`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    margin-bottom: 1px;
`;

export const CSSWidgetEditorListItemLabel = styled.div`
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 120px;
`;

export const CSSWidgetEditorListOption = styled.button`
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
